function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.54851e-18,0.090614,-0.090614,5.54851e-18,23.5986,-1.45245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.093,30.187L176.907,0L48.907,128L176.907,256L207.093,225.813L109.28,128L207.093,30.187Z",
    style: {
      fill: "rgb(10,45,113)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrement);
export default __webpack_public_path__ + "static/media/increment.27d2624bd3d1bb586df597cbefbf81da.svg";
export { ForwardRef as ReactComponent };